import { destinationFields } from '~/utils/destinationPath';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';
import type { NavigationLinkPlacement } from './NavigationLinkInteractionEvent';

export type NavigationLinkImpressionProperties = {
  destination_path?: string;
  destination_url?: string;
  label?: string;
  placement: NavigationLinkPlacement;
  position: number;
};

type EventData = {
  guestId?: string;
  href: string;
  isBot: boolean;
  label?: string;
  placement: NavigationLinkPlacement;
  position: number;
};

// The seen-side of NavigationLinkInteractionEvent, on the same keys so a link's impressions and
// clicks join.
class NavigationLinkImpressionEvent extends ImpressionEvent<
  EventData,
  NavigationLinkImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'navigation_link';
  }

  protected getImpressionProperties(): NavigationLinkImpressionProperties {
    return {
      ...destinationFields(this.data.href),
      label: this.data.label,
      placement: this.data.placement,
      position: this.data.position
    };
  }
}

export default NavigationLinkImpressionEvent;
